import React from "react";
import Selena from "../../assets/img/boxSelena.webp";
import styles from "./projectEmptyState.module.scss";
import { IconProjectSVG } from "../../assets/img/IconProjectSVG";
import SonicLink from "../../common/routing/SonicLink";

export const ProjectEmptyState: React.FC = () => {
  return (
    <div className={styles["p-pempty__wrapper"]}>
      <p className={styles["p-pempty__nocontents"]}>
        <IconProjectSVG width={100} height={100} />
        募集中のプロジェクトはありません
      </p>
      <div className={styles["p-pempty__make"]}>
        <img className={styles["p-pempty__img"]} src={Selena} />
        <div>
          <h2 className={styles["p-pempty__ttl"]}>
            プロジェクトを掲載してみませんか？
          </h2>
          <p className={styles["p-pempty__text"]}>
            プロジェクトを掲載することで仕事や企画、イベントのメンバーなどの募集を掲載できます。応募後のユーザー間のやりとりはSELeCTがサポートするので安心です。
          </p>
        </div>
      </div>
      <SonicLink
        to="/mypage/project/settings"
        className={styles["p-pempty__link"]}
      >
        マイページで作成してみる
      </SonicLink>
    </div>
  );
};

export default ProjectEmptyState;
